import React from 'react';
import { Link } from 'react-scroll';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';

const roadmapStages = [
    {
        title: 'BASIC WEB',
        salePrice: '$450',
        actualPrice: '$225',
        off: '50%',
        items: [
            '1 Page Website Design', 'HTML Based', '1 Banner Design', 'Contact/Query Form', '3 Revisions', 'Complete W3C Certified HTML', 'Complete Deployment'
        ]
    },
    {
        title: 'STARTUP WEB', 
        salePrice: '$750',
        actualPrice: '$375',
        off: '50%',
        items: [
            '3 Page Website Design', 'HTML Based', 'Hover Effects', '2 Banner Design', 'Sliding Banner', '2 Stock Photos (You can provide us more)', 'Contact/Query Form'
        ]
    },
    {
        title: 'PROFESSIONAL WEB',
        salePrice: '$1450',
        actualPrice: '$725',
        off: '50%',
        items: [
            'Up to 5 Pages Website Design', '3 Stock Photos (You can provide us more)', '3 Banner Designs', 'Sliding Banner', 'Hover Effects', 'Content Management'
        ]
    },
    {
        title: 'IDENTITY WEB',
        salePrice: '$2450',
        actualPrice: '$1225',
        off: '50%',
        items: [
            'Unique 5-Page Website Design', 'C.I.D. & High-End Web Design', 'Custom WordPress Development', '5 Stock Images', '5 Banner Designs'
        ]
    },
    {
        title: 'ELITE WEB',
        salePrice: '$3650',
        actualPrice: '$1825',
        off: '50%',
        items: [
            '10 Unique Pages Website Design', 'Custom, Interactive, Dynamic & High-End Design', 'Customize WordPress (or) PHP Development', 'Interactive Sliding'
        ]
    },
    {
        title: 'CORPORATE WEB',
        salePrice: '$4850',
        actualPrice: '$2425',
        off: '50%',
        items: [
            '15 to 20 Unique Pages Website Design', 'Custom Made, Interactive, Dynamic & High-End Design', 'Customized WordPress & PHP Development'
        ]
    },
    {
        title: 'CUSTOMIZED WEB PORTAL',
        salePrice: '$9800',
        actualPrice: '$4900',
        off: '50%',
        items: [
            'Complete Custom Design & Development', 'Job Portal', 'Professional Network Portal', 'Social Network Portal', 'Restaurant Portal', 'Medical Portal'
        ]
    },
    {
        title: 'GOLDEN CUSTOMIZED WEB',
        salePrice: '$19,400',
        actualPrice: '$9700',
        off: '50%',
        items: [
            'Customized Web Portal Package Included', 'Gold Customize Design & Development', 'Crypto-Based Portal', 'Job Portal', 'Professional'
        ]
    },
];

const Packages = () => {
    return (
        <section id="packages" className="meme_roadmap_section section_space">
            <div className="container">
                <div className="memecoin_heading_block text-center" data-aos="fade-up" data-aos-duration="800">
                    <h2 className="heading_text text-uppercase mb-0">CHOOSE YOUR PLAN</h2>
                </div>

                <div className="meme_roadmap_carousel">
                    <Swiper
                        loop={true}
                        spaceBetween={30}
                        grabCursor={false}
                        centeredSlides={true}
                        breakpoints={{
                            0: { slidesPerView: 1 },
                            991: { slidesPerView: 2 },
                            1025: { slidesPerView: 3 },
                            1700: { slidesPerView: 3 },
                        }}
                    >
                        {roadmapStages.map((stage, index) => (
                            <SwiperSlide key={index}>
                                <div className="meme_roadmap_block">
                                    <div className="roadmap_info">
                                        <h3 className="roadmap_title text-uppercase">{stage.title}</h3>
                                        <div className='d-flex gap-3 pb-5 pt-4'>
                                            <p style={{ fontSize: '40px', fontWeight: 'bold' }}>{stage.salePrice}</p>
                                            <p style={{ marginTop: '6px' }}><del>{stage.actualPrice}</del></p>
                                            <p style={{ marginTop: '6px' }}>{stage.off} OFF</p>
                                        </div>
                                        <ul className="iconlist_block unordered_list_block">
                                            {stage.items.map((item, itemIndex) => (
                                                <li key={itemIndex}>
                                                    <span className="iconlist_icon">
                                                        <i className="fa-regular fa-square-check"></i>
                                                    </span>
                                                    <span className="iconlist_label">{item}</span>
                                                </li>
                                            ))}
                                        </ul>
                                        <Link className="memecoin_btn mt-5 px-4 py-3 text-uppercase" style={{ backgroundColor: '#000', borderRadius: '30px', fontSize: '18px', letterSpacing: '1px' }} to="/token">
                                            Order Now
                                        </Link>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
};

export default Packages;
